import React from 'react'
import SimpleStoreGrid from '@scentregroup/shared/hub-components/store-grid/simple-store-grid'
import { AsMeasured } from '@scentregroup/shared/hub-components/as-measured'
import { ModuleProps } from '../../types'
import { SGPageTemplateContentCollection } from '../../../../../../src/types/page-templates'

function StoreGridModule({
  module,
}: ModuleProps<SGPageTemplateContentCollection>): JSX.Element | null {
  const { title, shortDescription } = module
  if (module.items.length === 0) {
    return null
  }

  return (
    <SimpleStoreGrid
      title={title || undefined}
      shortDescription={shortDescription || undefined}
      callToAction={module.callToAction || undefined}
      entries={module.items.map(item => ({
        ...item,
        // eslint-disable-next-line react/display-name
        as: asProps => (
          <AsMeasured
            {...asProps}
            metadata={item.analyticsMetadata}
            slot={module.analyticsMetadata?.displayId}
          />
        ),
      }))}
    />
  )
}

export default StoreGridModule
